import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import CompanyProfileWizard from '../../components/forms/CompanyProfileWizard';
import Icon from '../../components/AppIcon';

const ONBOARDING_BENEFITS = [
  { icon: 'Users', text: 'Attract top Virtual Assistants with a complete profile' },
  { icon: 'Search', text: 'Get matched with qualified candidates faster' },
  { icon: 'Shield', text: 'Build trust and credibility with your company details' },
  { icon: 'TrendingUp', text: 'Improve application rates on your job postings' },
];

const EmployerOnboarding = () => {
  const navigate = useNavigate();
  const { userProfile } = useAuth();

  const redirectToDashboard = () => {
    if (userProfile?.id) {
      localStorage.setItem(`employer_started_profile_${userProfile.id}`, 'true');
    }
    navigate('/employer-dashboard');
  };

  return (
    <div className="min-h-screen bg-background">
      <main className="pt-6 pb-20 md:pb-8">
        <div className="content-container px-4 sm:px-6 md:px-8">

          {/* Welcome Hero */}
          <div className="bg-gradient-to-r from-primary to-accent rounded-xl p-8 mb-8 text-white">
            <div className="flex items-start justify-between">
              <div>
                <h1 className="text-3xl font-bold mb-3">
                  Welcome to VA Sprouts{userProfile?.full_name ? `, ${userProfile.full_name}` : ''}!
                </h1>
                <p className="text-lg text-white/90 mb-6 max-w-2xl">
                  Let's set up your company profile so you can start connecting with talented Virtual Assistants.
                  A complete profile helps you stand out and attract the best candidates.
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {ONBOARDING_BENEFITS.map((benefit) => (
                    <div key={benefit.text} className="flex items-center gap-2 text-white/90">
                      <Icon name={benefit.icon} size={18} className="text-white flex-shrink-0" />
                      <span className="text-sm">{benefit.text}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Company Profile Wizard */}
          <CompanyProfileWizard onSuccess={redirectToDashboard} />

          {/* Skip Link */}
          <div className="text-center mt-6 mb-8">
            <button
              onClick={redirectToDashboard}
              className="text-sm text-text-tertiary hover:text-text-secondary transition-colors underline"
            >
              Skip for now — I'll complete my profile later
            </button>
          </div>

        </div>
      </main>
    </div>
  );
};

export default EmployerOnboarding;
